export const GET_NETWORKS = 'GET_NETWORKS';
export const SET_NETWORKS = 'SET_NETWORKS';
export const SET_LOADING = 'SET_LOADING';
export const ADD_NETWORKS_REQUEST = 'ADD_NETWORKS_REQUEST';
export const ADD_NETWORKS = 'ADD_NETWORKS';
export const EDIT_NETWORKS = 'EDIT_NETWORKS';
export const EDIT_NETWORKS_REQUEST = 'EDIT_NETWORKS_REQUEST';
export const DELETE_NETWORK = 'DELETE_NETWORK';
export const DELETE_NETWORKS_REQUEST = 'DELETE_NETWORKS_REQUEST';

export const getNetworks = () => ({ type: GET_NETWORKS });
export const setNetworks = (data) => ({ type: SET_NETWORKS, data });
export const editNetwork = (data) => ({ type: EDIT_NETWORKS, data });
export const setLoading = (data) => ({ type: SET_LOADING, data });
export const deleteNetwork = (data) => ({ type: DELETE_NETWORK, data });
export const editNetworksRequest = (data) => ({
  type: EDIT_NETWORKS_REQUEST,
  data,
});
export const deleteNetworksRequest = (data) => ({
  type: DELETE_NETWORKS_REQUEST,
  data,
});

export const addNetworksRequest = (data) => ({
  type: ADD_NETWORKS_REQUEST,
  data,
});

export const addNetworks = (data) => ({
  type: ADD_NETWORKS,
  data,
});
